import {useEffect} from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { createBrowserHistory } from 'history';
import Home from './Home'
import NotFound from './404'
// import Members from "./members"
import theme from "../theme/theme"
import { ThemeProvider} from '@mui/material/styles';
import client from '../client';
import { useSelector, useDispatch } from "react-redux";
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"
import SiteBuilder from "./siteBuilder";
import Header from "../components/header";
import Menu from "../components/menu";
import Footer from "../components/footer";
import Contact from "./contact";

import sdata from "../client/settings.json";
import planetStore from "../planet/planetstore";

// import Winterschool from "./Winterschool";
// import Projects from "./projects";


// // import themer
// // import './App.css';
// /*

// TODO:
//   - bring in client 
// - make project page
// - make member page
// - make 

// */

const DataHelper = () => {
  const data = useSelector(state => state.data);
  const dispatch = useDispatch();
  useEffect(() => {
    

    if (!data.client && dispatch){
      const cli = client(dispatch);
      dispatch({ type: DATA_ACTIONS.SET_CLIENT, client: cli});
    } 

    if (data.client && !data.data){      
      dispatch({type: DATA_ACTIONS.SET_DATA, data : sdata.settings})
    }

    if (!data.planetStore){
      dispatch({type: DATA_ACTIONS.SET_PLANET_STORE, planetStore: planetStore() })
    }

    if (data.planetStore && !data.planet){
      dispatch({type: DATA_ACTIONS.SET_PLANET, planet: data.planetStore.planets[0].name})
      dispatch({type: DATA_ACTIONS.SET_VARIABLE, variable: data.planetStore.variables[0]})
      dispatch({type: DATA_ACTIONS.SET_COORDINATES, coordinates: {x:0, y:0}})
      dispatch({type: DATA_ACTIONS.SET_HEIGHT, height: 10, })

      // const ls = localStorage.getItem("poi");
      // const res = ls?JSON.parse(ls):null;
      // console.log(res);
    }
  })
  return (
    null
  )
}

function PS() {
  const history = createBrowserHistory();
  return (
    <BrowserRouter history={history}>
        <DataHelper />
        <ThemeProvider theme={theme}>

          <div style={{width: "100%", background: "black", height: "0px"}} />
        
        <Header />
        <Menu />
        <div className="main">
         <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/contact' element={<Contact/>} />
            <Route path="/builder" element={<SiteBuilder />} />

            <Route path="*" element={<NotFound />} />
         </Routes>
         </div>
         <Footer />
         </ThemeProvider>
    </BrowserRouter>
  );
}

export default PS;


